(function () {
  var boot = window.themeVariables && window.themeVariables.wishlist;
  if (!boot || !boot.apiBase) return;
  boot.apiBase = String(boot.apiBase).replace(/\/+$/, '');

  var INSTALL_KEY = 'semode.installId.v1';
  var DISPLAY_KEY = 'semode.wishlist.display.v1';
  var PENDING_KEY = 'semode.wishlist.pending.v1';
  var strings = boot.strings || {};
  var copyNode = document.querySelector('[data-wishlist-copy]');
  if (copyNode) {
    try {
      var extra = JSON.parse(copyNode.textContent || '{}');
      Object.keys(extra).forEach(function (key) {
        if (extra[key]) strings[key] = extra[key];
      });
    } catch (e) {}
  }
  var items = [];
  var ready = false;
  var busy = false;
  var loggedIn = !!boot.loggedIn;
  var listStarted = false;

  function installId() {
    var id = localStorage.getItem(INSTALL_KEY);
    if (id) return id;
    id = (crypto.randomUUID && crypto.randomUUID()) ||
      'web-' + Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
    localStorage.setItem(INSTALL_KEY, id);
    return id;
  }

  function displayMap() {
    try {
      return JSON.parse(localStorage.getItem(DISPLAY_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function saveDisplay(map) {
    localStorage.setItem(DISPLAY_KEY, JSON.stringify(map));
  }

  function headers() {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Install-Id': installId()
    };
  }

  function usingProxy() {
    return !!(loggedIn && boot.proxyPath);
  }

  function wishlistUrl(pathAndQuery) {
    if (usingProxy()) return boot.proxyPath + pathAndQuery;
    return boot.apiBase + '/wishlist' + pathAndQuery;
  }

  function fetchWishlist(pathAndQuery, options) {
    return fetch(wishlistUrl(pathAndQuery), options).then(function (res) {
      if (!usingProxy()) return res;
      var type = res.headers.get('content-type') || '';
      if (type.indexOf('json') !== -1) return res;
      boot.proxyPath = '';
      return fetch(wishlistUrl(pathAndQuery), options);
    });
  }

  function registerDevice() {
    return fetch(boot.apiBase + '/wishlist/devices', {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({
        installId: installId(),
        platform: 'web',
        locale: boot.locale || null,
        customerId: boot.customerGid || null
      })
    });
  }

  function withDevice(run) {
    return run().then(function (res) {
      if (res.status !== 404 || usingProxy()) return res;
      return registerDevice().then(function () { return run(); });
    });
  }

  function isSaved(productId) {
    return items.some(function (item) { return item.productId === productId; });
  }

  function paint() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      var on = !!(id && isSaved(id));
      el.classList.toggle('is-saved', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      el.setAttribute('aria-label', on ? (strings.remove || 'Remove') : (strings.save || 'Save'));
    });
  }

  function whisper(kind) {
    var text = strings[kind] || '';
    if (!text) return;
    var node = document.querySelector('[data-wishlist-whisper]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'wishlist-whisper';
      node.setAttribute('data-wishlist-whisper', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.innerHTML = '';
    var label = document.createElement('span');
    label.textContent = text;
    node.appendChild(label);
    var drawer = document.getElementById('wishlist-drawer');
    if ((kind === 'saved' || kind === 'removed') && !(drawer && drawer.hasAttribute('data-wishlist-hide-view'))) {
      var link = document.createElement('button');
      link.type = 'button';
      link.setAttribute('data-wishlist-open', '');
      link.textContent = strings.viewList || 'View list';
      node.appendChild(link);
    }
    node.classList.add('is-on');
    clearTimeout(whisper.timer);
    whisper.timer = setTimeout(function () { node.classList.remove('is-on'); }, 2400);
  }

  function cacheFromButton(btn) {
    return {
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || '',
      compare: btn.getAttribute('data-product-compare') || ''
    };
  }

  function loginHref() {
    var url = boot.loginUrl || '/account/login';
    var returnTo = location.pathname + location.search + location.hash;
    try {
      var parsed = new URL(url, location.origin);
      parsed.searchParams.set('return_to', returnTo);
      return parsed.toString();
    } catch (e) {
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'return_to=' + encodeURIComponent(returnTo);
    }
  }

  function openDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer) drawer.open = true;
  }

  function isWishlistHref(href) {
    if (!href) return false;
    try {
      var parsed = new URL(href, location.origin);
      return parsed.pathname.indexOf('/pages/wishlist') === 0 || parsed.searchParams.get('view') === 'wishlist';
    } catch (e) {
      return href.indexOf('/pages/wishlist') >= 0 || href.indexOf('view=wishlist') >= 0;
    }
  }

  function ancestorHidden(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (node.matches && node.matches('.drawer:not([open]), .popover:not([open])')) return true;
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
      node = node.parentElement;
    }
    return false;
  }

  function pickAccountHost() {
    var preferred = [
      document.querySelector('shopify-account.mobile-bottom-navigation__account-trigger'),
      document.querySelector('shopify-account.header__account-component'),
      document.querySelector('shopify-account.wishlist-account-host'),
      document.querySelector('shopify-account.snav-footer__account-host')
    ];
    var i;
    for (i = 0; i < preferred.length; i++) {
      if (preferred[i] && !ancestorHidden(preferred[i])) return preferred[i];
    }
    var all = document.querySelectorAll('shopify-account');
    for (i = 0; i < all.length; i++) {
      if (!ancestorHidden(all[i])) return all[i];
    }
    return preferred[2] || null;
  }

  function openLogin() {
    var host = pickAccountHost();
    var root = host && host.shadowRoot;
    var dialog = root && root.querySelector('dialog');
    if (dialog && dialog.open) return;
    var trigger = root && root.querySelector('.account-button, button, [slot="signed-out-avatar"]');
    if (trigger) {
      trigger.click();
      return;
    }
    if (host) {
      host.click();
      return;
    }
    location.href = loginHref();
  }

  function requireLogin(btn) {
    if (loggedIn) return false;
    if (btn) {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        productId: btn.getAttribute('data-product-id') || '',
        handle: btn.getAttribute('data-product-handle') || '',
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '',
        image: btn.getAttribute('data-product-image') || '',
        price: btn.getAttribute('data-product-price') || '',
        compare: btn.getAttribute('data-product-compare') || '',
        variantId: btn.getAttribute('data-variant-id') || '',
        variantLabel: btn.getAttribute('data-variant-label') || ''
      }));
    }
    openLogin();
    return true;
  }

  function resumePending() {
    if (!loggedIn) return;
    var raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return;
    sessionStorage.removeItem(PENDING_KEY);
    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!pending || !pending.productId) return;
    var btn = document.querySelector('[data-wishlist-toggle][data-product-id="' + pending.productId + '"]');
    if (!btn) {
      btn = document.createElement('button');
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-product-id', pending.productId);
      btn.setAttribute('data-product-handle', pending.handle || '');
      btn.setAttribute('data-product-title', pending.title || '');
      btn.setAttribute('data-product-url', pending.url || '');
      btn.setAttribute('data-product-image', pending.image || '');
      btn.setAttribute('data-product-price', pending.price || '');
      btn.setAttribute('data-product-compare', pending.compare || '');
      if (pending.variantId) btn.setAttribute('data-variant-id', pending.variantId);
      if (pending.variantLabel) btn.setAttribute('data-variant-label', pending.variantLabel);
    }
    toggle(btn);
  }

  function toggle(btn) {
    if (requireLogin(btn)) return;
    var productId = btn.getAttribute('data-product-id');
    if (!productId || busy) return;
    busy = true;
    var cached = cacheFromButton(btn);
    var on = isSaved(productId);
    var req = on
      ? withDevice(function () {
        return fetchWishlist('/items/' + encodeURIComponent(productId), {
          method: 'DELETE',
          headers: headers()
        });
      })
      : withDevice(function () {
        return fetchWishlist('/items/' + encodeURIComponent(productId), {
          method: 'PUT',
          headers: headers(),
          body: JSON.stringify({
            variantId: btn.getAttribute('data-variant-id') || '',
            variantLabel: btn.getAttribute('data-variant-label') || null,
            notifyOnRestock: false,
            notifyOnPriceDrop: false
          })
        });
      });

    req.then(function (res) {
      if (on) {
        if (!res.ok && res.status !== 404) throw new Error('remove');
        items = items.filter(function (item) { return item.productId !== productId; });
        return;
      }
      if (!res.ok) throw new Error('add');
      return res.json().then(function (json) {
        if (json.item) {
          items = items.filter(function (item) { return item.productId !== productId; }).concat([json.item]);
        }
        var map = displayMap();
        map[productId] = cached;
        saveDisplay(map);
      });
    }).then(function () {
      paint();
      renderPage();
    }).catch(function () {
      whisper('error');
    }).then(function () {
      busy = false;
    });
  }

  function displayFor(item) {
    var map = displayMap();
    return map[item.productId] || {};
  }

  function isVariantGid(id) {
    return typeof id === 'string' && id.indexOf('gid://shopify/ProductVariant/') === 0;
  }

  function deleteVariant(productId, variantId) {
    return withDevice(function () {
      return fetchWishlist(
        '/items/' + encodeURIComponent(productId) +
          '?variantId=' + encodeURIComponent(variantId || ''),
        { method: 'DELETE', headers: headers() }
      );
    }).then(function (res) {
      if (!res.ok && res.status !== 404) throw new Error('remove');
    }).catch(function () {});
  }

  function collapseItems(list) {
    var best = {};
    (list || []).forEach(function (item) {
      var prev = best[item.productId];
      if (!prev || (isVariantGid(item.variantId) && !isVariantGid(prev.variantId))) {
        best[item.productId] = item;
      }
    });
    return Object.keys(best).map(function (key) { return best[key]; });
  }

  function dropReplaced(list, kept) {
    var keep = {};
    kept.forEach(function (item) {
      keep[item.productId + '\0' + (item.variantId || '')] = true;
    });
    list.forEach(function (item) {
      if (keep[item.productId + '\0' + (item.variantId || '')]) return;
      deleteVariant(item.productId, item.variantId);
    });
  }

  function accountSignedIn() {
    if (boot.loggedIn) return true;
    var hosts = document.querySelectorAll('shopify-account');
    var i;
    for (i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (root && root.querySelector('.account-button__avatar')) return true;
    }
    return false;
  }

  function syncLoggedIn() {
    var next = accountSignedIn();
    if (next === loggedIn) return loggedIn;
    loggedIn = next;
    if (loggedIn) startList();
    else renderPage();
    return loggedIn;
  }

  function startList() {
    if (listStarted) return;
    listStarted = true;
    ready = false;
    renderPage();
    (usingProxy() ? Promise.resolve() : registerDevice())
      .then(function () {
        return fetchWishlist('', { headers: headers() });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('list');
        return res.json();
      })
      .then(function (json) {
        var raw = json.items || [];
        items = collapseItems(raw);
        dropReplaced(raw, items);
        ready = true;
        paint();
        renderPage();
        resumePending();
      })
      .catch(function () {
        ready = true;
        var error = document.querySelector('[data-wishlist-error]');
        if (error) error.dataset.failed = 'true';
        renderPage();
      });
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var content = root.querySelector('.wishlist-drawer__content');
    var loading = root.querySelector('[data-wishlist-loading]');
    var error = root.querySelector('[data-wishlist-error]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var list = root.querySelector('[data-wishlist-list]');
    var hint = root.querySelector('[data-wishlist-login-hint]');
    if (content) content.classList.toggle('drawer__content--center', !loggedIn);
    if (hint) hint.hidden = loggedIn;
    if (!loggedIn) {
      if (loading) loading.hidden = true;
      if (error) error.hidden = true;
      if (empty) empty.hidden = true;
      if (list) list.hidden = true;
      return;
    }
    if (loading) loading.hidden = ready;
    if (!ready) {
      if (error) error.hidden = true;
      if (empty) empty.hidden = true;
      if (list) list.hidden = true;
      return;
    }
    var failed = error && error.dataset.failed === 'true';
    if (error) error.hidden = !failed;
    if (failed) {
      if (empty) empty.hidden = true;
      if (list) list.hidden = true;
      return;
    }
    if (!items.length) {
      if (empty) empty.hidden = false;
      if (list) {
        list.hidden = true;
        list.innerHTML = '';
      }
      return;
    }
    if (empty) empty.hidden = true;
    if (!list) return;
    list.hidden = false;
    list.innerHTML = items.map(function (item) {
      var meta = displayFor(item);
      var href = meta.url || (meta.handle ? '/products/' + meta.handle : '#');
      var title = meta.title || '—';
      var image = meta.image
        ? '<img src="' + escapeAttr(meta.image) + '" alt="" width="216" height="292">'
        : '';
      var showMeta = list.getAttribute('data-show-meta') !== 'false';
      var showCompare = list.getAttribute('data-show-compare') !== 'false';
      var sale = meta.compare ? ' is-sale' : '';
      var price = meta.price
        ? '<span class="wishlist-drawer__price' + sale + '">' + escapeHtml(meta.price) + '</span>'
        : '';
      var compare = showCompare && meta.compare
        ? '<s class="wishlist-drawer__compare">' + escapeHtml(meta.compare) + '</s>'
        : '';
      var label = showMeta && item.variantLabel
        ? '<p class="wishlist-drawer__meta">' + escapeHtml(item.variantLabel) + '</p>'
        : '';
      return (
        '<li class="wishlist-drawer__row">' +
          '<a class="wishlist-drawer__thumb" href="' + escapeAttr(href) + '">' + image + '</a>' +
          '<div class="wishlist-drawer__body">' +
            '<div class="wishlist-drawer__top">' +
              '<a class="wishlist-drawer__name" href="' + escapeAttr(href) + '">' + escapeHtml(title) + '</a>' +
              '<button type="button" class="wishlist-drawer__remove" data-wishlist-toggle data-product-id="' +
                escapeAttr(item.productId) +
                '" data-product-handle="' + escapeAttr(meta.handle || '') +
                '" data-product-title="' + escapeAttr(title) +
                '" data-product-url="' + escapeAttr(href) +
                '" data-product-image="' + escapeAttr(meta.image || '') +
                '" data-product-price="' + escapeAttr(meta.price || '') +
                '" data-product-compare="' + escapeAttr(meta.compare || '') +
                '" aria-label="' + escapeAttr(strings.remove || 'Remove') + '" aria-pressed="true">' +
                '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 00-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 00-.1-7.8z" fill="currentColor"></path></svg>' +
              '</button>' +
            '</div>' +
            label +
            '<div class="wishlist-drawer__prices">' + price + compare + '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest('[data-wishlist-toggle], [data-wishlist-open], [data-wishlist-login]')) {
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-wishlist-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openDrawer();
      return;
    }
    var link = event.target.closest('a[href]');
    if (link && isWishlistHref(link.getAttribute('href'))) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openDrawer();
      return;
    }
    var login = event.target.closest('[data-wishlist-login]');
    if (login) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openLogin();
      return;
    }
    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    toggle(btn);
  }, true);

  if (isWishlistHref(location.href)) {
    openDrawer();
  }

  if (loggedIn) {
    startList();
  } else {
    ready = true;
    paint();
    renderPage();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(function () {
      syncLoggedIn();
      document.querySelectorAll('shopify-account').forEach(function (host) {
        if (!host.shadowRoot) return;
        new MutationObserver(syncLoggedIn).observe(host.shadowRoot, { childList: true, subtree: true });
      });
    });
  }

  document.addEventListener('click', function (event) {
    var retry = event.target.closest('[data-wishlist-retry]');
    if (!retry) return;
    event.preventDefault();
    if (!loggedIn) {
      openLogin();
      return;
    }
    var error = document.querySelector('[data-wishlist-error]');
    if (error) error.dataset.failed = '';
    ready = false;
    renderPage();
    fetchWishlist('', { headers: headers() })
      .then(function (res) {
        if (!res.ok) throw new Error('list');
        return res.json();
      })
      .then(function (json) {
        var raw = json.items || [];
        items = collapseItems(raw);
        dropReplaced(raw, items);
        ready = true;
        paint();
        renderPage();
      })
      .catch(function () {
        ready = true;
        if (error) error.dataset.failed = 'true';
        renderPage();
      });
  });

  window.semodeWishlist = window.semodeWishlist || {};
  window.semodeWishlist.paint = paint;
  window.semodeWishlist.openLogin = openLogin;
})();
